module.exports = __webpack_public_path__ + "static/voa_card-ddf0a82aeecb53266d96261c1c666b73.png";